export const initialValues = values => ({
  /* BUSINESS TYPE */
  '2313PuborWineBar': {
    code: '',
    value: ''
  },
  /* CATEGORY CUISINE */
  RestaurantType: {
    code: '',
    value: ''
  },
  /* ANNUAL TURNOVER */
  '2313Turnover': undefined,
  /* NUMBER OF EMPLOYEES */
  '2313Employees': 0,
  '2313wageroll': 0,
  /* BASIC INFO */
  '2313Businessstatus': {
    code: '',
    value: ''
  },
  Signs: {
    code: '£2,500',
    value: '£2,500'
  },
  PropertyOpen: {
    code: '£2,500',
    value: '£2,500'
  },
  '2313tradingname': '',
  '2313riskaddress': {
    postcode: '',
    addressline1: '',
    addressline2: '',
    town: ''
  },
  underPAYELimitYN: '',
  '2313ERN': '',
  /* EXPERIENCE */
  '2313yearstradingatthisaddress': {
    code: '',
    value: ''
  },
  PrevExperience: '',
  '2313yrstradeexpDB': {
    code: '',
    value: ''
  },
  '2313SeasonalYN': {
    code: '',
    value: ''
  },
  TradeInfo: '',
  FCTraining: {
    code: '',
    value: ''
  },
  /* CLAIMS */
  '2313claimsYn': {
    code: '',
    value: ''
  },
  /* BUSINESS PREMISES */
  '2313GSofRYN': {
    code: '',
    value: ''
  },
  '2313SCYN': {
    code: '',
    value: ''
  },
  '2313notSCTXT': '',
  '2313soleoccYN': {
    code: '',
    value: ''
  },
  '2313notoccsolelyTXT': '',
  /* CONSTRUCTION SPECIFICATION */
  '2313stndconYN': {
    code: '',
    value: ''
  },
  '2313stndconNTXT': '',
  '2313stndroofconYN': {
    code: '',
    value: ''
  },
  '2313roofstndconNTXT': '',
  '2313flatroofYN': {
    code: '',
    value: ''
  },
  '2313flatroofPCT': '0',
  '2313flatroofconstruction': {
    code: '',
    value: ''
  },
  '2313flatroofother': '',
  '2313AgeBuildDB': {
    code: '',
    value: ''
  },
  Pre1700: undefined,
  /* PREMISE DETAILS */
  '2313listedYN': {
    code: '',
    value: ''
  },
  '2313listedYDB': {
    code: '',
    value: ''
  },
  '2313locationYN': {
    code: '',
    value: ''
  },
  '2313infoshopcentTB': '',
  '2313owneroccYN': {
    code: '',
    value: ''
  },
  '2313ressccYN': {
    code: '',
    value: ''
  },
  AccommodationInfo: '',
  /* EXPOSURE TO DISASTERS */
  '2313floodYN': {
    code: '',
    value: ''
  },
  '2313FloodInfo': '',
  '2313subsidenceYN': {
    code: '',
    value: ''
  },
  SubsInfo: '',
  /* INSTALLATIONS */
  '2313IEECertYN': {
    code: '',
    value: ''
  },
  OpenFire: {
    code: '',
    value: ''
  },
  /* KITCHEN INFO */
  '2313CookingYN': {
    code: '',
    value: ''
  },
  '2313FryingYN': {
    code: '',
    value: ''
  },
  '2313FullRangeYN': {
    code: '',
    value: ''
  },
  '2313CleanMainYN': {
    code: '',
    value: ''
  },
  '2313RangeMainYN': {
    code: '',
    value: ''
  },
  '2313PresCookYN': {
    code: '',
    value: ''
  },
  /* CATERING INFO */
  '2313noofcoversN': undefined,
  '2313SontheDDB': {
    code: '',
    value: ''
  },
  ClosingTime: {
    code: '',
    value: ''
  },
  '2313latelicense': {
    code: '',
    value: ''
  },
  '2313latelicensetime': '',
  /* ENTERTAINMENT INFO */
  2313: {
    code: '',
    value: ''
  },
  MusicOften: {
    code: '',
    value: ''
  },
  '2381musicdetails': '',
  '2313dancefloorYN': {
    code: '',
    value: ''
  },
  '3093Spillage': {
    code: '',
    value: ''
  },
  '2313entfeeYn': {
    code: '',
    value: ''
  },
  entranceFeeDetails: '',
  /* STAFF & GUESTROOMS */
  '2313doormenYN': {
    code: '',
    value: ''
  },
  '2313lincdoorYN': {
    code: '',
    value: ''
  },
  DoorStaffInfo: '',
  '2313roomsYn': {
    code: '',
    value: ''
  },
  '2313NoroomsDB': undefined,
  /* EVENT HIRE & DELIVERY */
  '2313eventhireYN': {
    code: '',
    value: ''
  },
  EventHireInfo: '',
  '2313outcaterYN': {
    code: '',
    value: ''
  },
  '2313OCdetails': '',
  '2313turnoverOC': {
    code: '',
    value: ''
  },
  Delivery: {
    code: '',
    value: ''
  },
  HowDelivery: {
    code: '',
    value: ''
  },
  CarDelivery: undefined,
  BikeDelivery: undefined,
  /* MISCELLANEOUS */
  Shisha: {
    code: '',
    value: ''
  },
  '2313childrensplayareaYN': {
    code: '',
    value: ''
  },
  '2381CPADetails': '',
  '2313ATMYN': {
    code: '',
    value: ''
  },
  '2313ATMrespon': {
    code: '',
    value: ''
  },
  '2313ATMlimit': undefined,
  '2313ATMboltedownYN': {
    code: '',
    value: ''
  },
  '2313ATMemptiedYN': {
    code: '',
    value: ''
  },
  '2313ATMCCTVYN': {
    code: '',
    value: ''
  },
  /* SECURITY REQUIREMENTS */
  '2313minsecYN': {
    code: '',
    value: ''
  },
  MinSecInfo: '',
  /* PREMISES PROTECTION AND ALARM */
  '2313alarmYN': {
    code: '',
    value: ''
  },
  '2313typealarmDB': {
    code: '',
    value: ''
  },
  PoliceResponse: {
    code: '',
    value: ''
  },
  PoliceResponseLevel: {
    code: '',
    value: ''
  },
  '2313grillesYN': {
    code: '',
    value: ''
  },
  '2313shuttYN': {
    code: '',
    value: ''
  },
  /* FIRE DETECTION AND ALARM */
  FireAlarmYN: {
    code: '',
    value: ''
  },
  FireAssess: {
    code: '',
    value: ''
  },
  FireMeasures: '',
  Ansul: {
    code: '',
    value: ''
  },
  FireAlarm: {
    code: '',
    value: ''
  },
  FireAlarmInfo: {
    code: '',
    value: ''
  },
  /* CCTV & VIDEO SURVEILLANCE */
  '2313cctvDB': {
    code: '',
    value: ''
  },
  CCTVRecord: {
    code: '',
    value: ''
  },
  CCTVDays: undefined,
  CCTVOffsite: {
    code: '',
    value: ''
  },
  /* HEALTH AND SAFETY POLICY */
  '2313HSassess': {
    code: '',
    value: ''
  },
  '2313HSPolicy': {
    code: '',
    value: ''
  },
  /* SUMS INSURED */
  '2313BuildSIM': 0,
  LossofRent: 0,
  PlayingSurfaces: 0,
  '2313TIM': 0,
  '2313TradeContM': 0,
  '2313EleEquipM': 0,
  '2313Stock': 0,
  '2313WSM': 0,
  LossOfLicenceYesNo: false,
  '2313TobaccoM': 0,
  '2313FFM': 2000,
  '2313BusIntLimit': 500000,
  '4072IndemnityPeriod': {
    code: '12months',
    value: '12 Months'
  },
  '2313GoodsInTransit': 2000,
  '2313MoneyTransitM': 5000,
  '2313MoneySafeM': 2000,
  PersonalContents: false,
  '2313DomContM': 0,
  /* POINT OF CONTACT */
  FirstName: values?.firstName || '',
  LastName: values?.lastName || '',
  Email: values?.email || '',
  Phone: values?.phone || '',
  /* COVER START */
  EffectivePeriodStartDate: '',
  /* ACCEPTANCE CRITERIA */
  '2313disclosheader6': '',
  '2313declinedetails': '',
  Void: '',
  VoidInfo: '',
  NonCompliance: '',
  NonComplianceInfo: '',
  CriminalRecord: '',
  CriminalRecordInfo: '',
  DecHSGen: '',
  DecHSGenInfo: '',
  '2313disclosureheader3': '',
  '2313convictiondetails': '',
  DecHSCleanup: '',
  DecHSCleanupInfo: '',
  HSVessels: '',
  HSObligations: '',
  '2313disclosheader4': '',
  '2313CCJdetails': '',
  Disqualified: '',
  DisqualifiedInfo: '',
  CCJPersonal: '',
  CCJPersonalinfo: '',
  CCJBusiness: '',
  CCJBusinessInfo: '',
  '2313disclosheader5': '',
  '2313admindetails': '',
  '2313ERNexempt': 'No'

  // ...JSON.parse(
  //   '{"2313":{"code":"false","value":"No"},"2313PuborWineBar":{"code":"fishAndChipShop","value":"Fish & Chip Shop"},"RestaurantType":{"code":"American","value":"American"},"2313Turnover":321,"2313Employees":0,"2313wageroll":"","2313Businessstatus":{"code":"soleTrader","value":"Sole Trader"},"Signs":{"code":"£2,500","value":"£2,500"},"PropertyOpen":{"code":"£2,500","value":"£2,500"},"2313tradingname":"TestName","2313riskaddress":{"postcode":"AB10 1AB","addressline1":"Marischal College","addressline2":"Broad Street","town":"Aberdeen","county":"Aberdeenshire"},"underPAYELimitYN":"","2313ERN":"","2313yearstradingatthisaddress":{"code":"oneYear","value":"1"},"PrevExperience":"","2313yrstradeexpDB":{"code":"oneYear","value":"1"},"2313SeasonalYN":{"code":"true","value":"Yes"},"TradeInfo":"","FCTraining":{"code":"","value":""},"2313claimsYn":{"code":"false","value":"No"},"2313GSofRYN":{"code":"true","value":"Yes"},"2313SCYN":{"code":"true","value":"Yes"},"2313notSCTXT":"","2313soleoccYN":{"code":"true","value":"Yes"},"2313notoccsolelyTXT":"","2313stndconYN":{"code":"true","value":"Yes"},"2313stndconNTXT":"","2313stndroofconYN":{"code":"true","value":"Yes"},"2313roofstndconNTXT":"","2313flatroofYN":{"code":"false","value":"No"},"2313flatroofPCT":0,"2313flatroofconstruction":{"code":"","value":""},"2313flatroofother":"","2313AgeBuildDB":{"code":"post1850","value":"Post 1850"},"2313listedYN":{"code":"false","value":"No"},"2313listedYDB":{"code":"","value":""},"2313locationYN":{"code":"false","value":"No"},"2313infoshopcentTB":"","2313owneroccYN":{"code":"false","value":"No"},"2313ressccYN":{"code":"false","value":"No"},"AccommodationInfo":"","2313floodYN":{"code":"true","value":"Yes"},"2313FloodInfo":"","2313subsidenceYN":{"code":"true","value":"Yes"},"SubsInfo":"","2313IEECertYN":{"code":"true","value":"Yes"},"OpenFire":{"code":"true","value":"Yes"},"2313CookingYN":{"code":"","value":""},"2313FryingYN":{"code":"false","value":"No"},"2313FullRangeYN":{"code":"false","value":"No"},"2313CleanMainYN":{"code":"","value":""},"2313RangeMainYN":{"code":"","value":""},"2313PresCookYN":{"code":"false","value":"No"},"2313noofcoversN":321,"2313SontheDDB":{"code":"one","value":"1"},"ClosingTime":{"code":"","value":""},"2313latelicense":{"code":"false","value":"No"},"2313latelicensetime":"","MusicOften":{"code":"false","value":"No"},"2381musicdetails":"","2313dancefloorYN":{"code":"false","value":"No"},"3093Spillage":{"code":"true","value":"Yes"},"2313entfeeYn":{"code":"false","value":"No"},"2313doormenYN":{"code":"false","value":"No"},"2313lincdoorYN":{"code":"","value":""},"DoorStaffInfo":"","2313roomsYn":{"code":"false","value":"No"},"2313eventhireYN":{"code":"false","value":"No"},"EventHireInfo":"","2313outcaterYN":{"code":"false","value":"No"},"2313OCdetails":"","2313turnoverOC":{"code":"","value":""},"Delivery":{"code":"false","value":"No"},"HowDelivery":{"code":"","value":""},"Shisha":{"code":"false","value":"No"},"2313childrensplayareaYN":{"code":"false","value":"No"},"2381CPADetails":"","2313ATMYN":{"code":"false","value":"No"},"2313ATMrespon":{"code":"","value":""},"2313ATMboltedownYN":{"code":"","value":""},"2313ATMemptiedYN":{"code":"","value":""},"2313ATMCCTVYN":{"code":"","value":""},"2313minsecYN":{"code":"true","value":"Yes"},"MinSecInfo":"","2313alarmYN":{"code":"false","value":"No"},"2313typealarmDB":{"code":"","value":""},"PoliceResponse":{"code":"","value":""},"PoliceResponseLevel":{"code":"","value":""},"2313grillesYN":{"code":"frontAndBack","value":"Front & Back"},"2313shuttYN":{"code":"no","value":"No"},"FireAlarmYN":{"code":"","value":""},"FireAssess":{"code":"","value":""},"FireMeasures":"","Ansul":{"code":"","value":""},"FireAlarm":{"code":"","value":""},"FireAlarmInfo":{"code":"","value":""},"2313cctvDB":{"code":"false","value":"No"},"CCTVRecord":{"code":"","value":""},"CCTVOffsite":{"code":"","value":""},"2313HSassess":{"code":"","value":""},"2313HSPolicy":{"code":"","value":""},"2313BuildSIM":0,"LossofRent":0,"PlayingSurfaces":0,"2313TIM":0,"2313TradeContM":0,"2313EleEquipM":0,"2313Stock":0,"2313WSM":0,"LossOfLicenceYesNo":false,"2313TobaccoM":0,"2313FFM":2000,"2313BusIntLimit":500000,"4072IndemnityPeriod":{"code":"12months","value":"12 Months"},"2313GoodsInTransit":2000,"2313MoneyTransitM":5000,"2313MoneySafeM":2000,"PersonalContents":false,"2313DomContM":0,"FirstName":"Josip","LastName":"Delac","Email":"josip.delac@coreline.agency","Phone":"9321321","EffectivePeriodStartDate":"","2313disclosheader6":"Yes","2313declinedetails":"","Void":"Yes","VoidInfo":"","NonCompliance":"Yes","NonComplianceInfo":"","CriminalRecord":"Yes","CriminalRecordInfo":"","DecHSGen":"Yes","DecHSGenInfo":"","2313disclosureheader3":"Yes","2313convictiondetails":"","DecHSCleanup":"Yes","DecHSCleanupInfo":"","HSVessels":"Yes","HSObligations":"Yes","2313disclosheader4":"Yes","2313CCJdetails":"","Disqualified":"Yes","DisqualifiedInfo":"","CCJPersonal":"Yes","CCJPersonalinfo":"","CCJBusiness":"Yes","CCJBusinessInfo":"","2313disclosheader5":"Yes","2313admindetails":"","Web Address":"www.test.com","SpecialTerms":"Yes"}'
  // ),
});
